import ConfigAnalytics from './ConfigAnalytics';
import ConfigBehaviour from './ConfigBehaviour';
import ConfigCaptions from './ConfigCaptions';
import ConfigEnvironment from './ConfigEnvironment';
import ConfigServiceUrls from './ConfigServiceUrls';
import ConfigText from './ConfigText';

class Config {
    serviceUrls = new ConfigServiceUrls();
    text = new ConfigText();
    behaviour = new ConfigBehaviour();
    analytics = new ConfigAnalytics();
    environment = new ConfigEnvironment();
    captions = new ConfigCaptions();

    constructor() {
        Object.freeze(this);
    }
}

export default Config;
